import { spawn, all } from 'redux-saga/effects';
import licenseSagas from './license.sagas';
import siteSagas from './site.sagas';
import personSagas from './person.sagas';
import accountingSagas from './accounting.sagas';
import inspectionSagas from './inspection.sagas';
import violationSagas from './violation.sagas';
import calendarSagas from './calendar.sagas';
import timeSheetSagas from './timeSheet.sagas';
import citationSagas from './citation.sagas';
import inboxSagas from './inbox.sagas';

export default function* rootSaga() {
    yield all([
        spawn(licenseSagas),
        spawn(siteSagas),
        spawn(personSagas),
        spawn(accountingSagas),
        spawn(inspectionSagas),
        spawn(violationSagas),
        spawn(calendarSagas),
        spawn(timeSheetSagas),
        spawn(citationSagas),
        spawn(inboxSagas),
    ]);
}
